"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.multiChangeFormFields = void 0;

var _lodash = require("lodash");

var _reduxForm = require("redux-form");

/**
 *
 * Redux form is great!
 *     ...but it's got a few bugs and here are our tools to work around them until they get fixed.
 *
 */

/**
 * Redux form does not currently have an action and reducer for changing multiple
 * fields at once. Long-term it would be good to add this either to redux-form
 * or as an action + plugin set, but the change logic is complicated enough and
 * currently in enough flux that my solution here is to just dispatch individual
 * change actions for each field in values.
 *
 * @param dispatch func
 * @param form string
 * @param values object
 * @param args
 */
var multiChangeFormFields = function multiChangeFormFields(dispatch, form, values) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  (0, _lodash.forEach)(values, function (value, field) {
    return dispatch(_reduxForm.change.apply(void 0, [form, field, value].concat(args)));
  });
};

exports.multiChangeFormFields = multiChangeFormFields;
//# sourceMappingURL=multiChangeFormFields.js.map